export function uid(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function apiToken(): string {
  const raw = uid().replace(/-/g, '') + uid().replace(/-/g, '');
  return raw.slice(0, 32);
}

export function trackingCode(): string {
  const raw = uid().replace(/-/g, '');
  return `sf_${raw.slice(0, 12)}`;
}

export function visitorId(): string {
  const key = 'sf_vid';
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const next = uid();
    localStorage.setItem(key, next);
    return next;
  } catch {
    return uid();
  }
}

export function maskIp(ip: string): string {
  if (!ip) return '未知 IP';
  const parts = ip.split('.');
  if (parts.length === 4) return `${parts[0]}.${parts[1]}.*.*`;
  if (ip.includes(':')) return ip.split(':').slice(0, 3).join(':') + ':*';
  return ip;
}
